import React from 'react'
import PropTypes from 'prop-types'

import ProductAnalyticsTable from './ProductAnalyticsTable'

function ProductAnalyticsTopKeywordsDashboard({ keywords, tiersData }) {
  return (
    <ProductAnalyticsTable
      type=""
      keywords={keywords}
      searchTerm=""
      searchKeyword={() => {}}
      fetch={() => {}}
      tiersData={tiersData}
      scope="top"
    />
  )
}

ProductAnalyticsTopKeywordsDashboard.propTypes = {
  keywords: PropTypes.object.isRequired,
  tiersData: PropTypes.object.isRequired,
}

export default ProductAnalyticsTopKeywordsDashboard
